import React from 'react';
import { Navigate } from 'react-router-dom';
import { useLang } from '../lib/lang';

// Старая страница тарифов: тарифы теперь на странице продукта «Сегментация КЛКТ».
const SubscriptionPage = () => {
  const { to } = useLang();
  return <Navigate to={to('/products/cbct-segmentation') + '#tariffs'} replace />;
};

export default SubscriptionPage;
